import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Radio, RadioGroup, Spinner } from '@nextui-org/react'
import { enqueueSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { MdChecklist, MdInfo } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import StepCard from './StepCard'
import { useStepFooterAction } from '../context/StepFooterActionContext'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { useParams } from 'react-router-dom'
import { IConfigSeller } from '@/models/configSeller'
import { isConsole } from '@/utils/isConsole'

interface IChecklistProps {
  // Cuando es true, abre automáticamente el modal del checklist al cargar el tradein
  // (usado por la página standalone /:slug/checklist/:id). Por defecto false para no
  // alterar el comportamiento dentro de TradeInPage.
  autoOpen?: boolean
}

const Checklist: React.FC<IChecklistProps> = ({ autoOpen = false }) => {
  const { ctx, saveCtx } = useTradeinContext()
  const [loading, setLoading] = useState(false)
  const userState = useSelector((store: IAppStore) => store.user)
  const [questionsLength, setQuestionsLength] = useState(0)
  const { slug } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isSamsungRomPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isTabletFalabella = isFalabellaChile && ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Samsung'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isNovabench = (isMacstoreMexico || isFalabellaChile || isRipleyChile) && ctx.tradein.sbu === 'Notebook'
  const isNovabenchFlabella = isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isTabletSamsungRom = isSamsungRomPeru && ctx.tradein.sbu === 'Tablet' && ctx.tradein.brand === 'Samsung'
  const isSmartWatchSamsungMx = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx' && ctx.tradein.sbu === 'Smartwatch'
  const isSmartWatchHuaweiMx = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx' && ctx.tradein.sbu === 'Smartwatch'
  const isSmartWatchFalabella = isFalabellaChile && ctx.tradein.sbu === 'Smartwatch'
  const isTabletSamsungMx = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx' && ctx.tradein.sbu === 'Tablet'
  const isTabletHuaweiMx = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx' && ctx.tradein.sbu === 'Tablet'
  const isTabletHuaweiPe = configSeller.config.s3.FOLDER_APP === 'ti_huawei_pe' && ctx.tradein.sbu === 'Tablet'
  const isSmartWatchHuaweiPe = configSeller.config.s3.FOLDER_APP === 'ti_huawei_pe' && ctx.tradein.sbu === 'Smartwatch'
  const isSmartWatchHuaweiChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl' && ctx.tradein.sbu === 'Smartwatch'
  const isTabletHuaweiChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl' && ctx.tradein.sbu === 'Tablet'
  const isComputerRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl' && ctx.tradein.sbu === 'Notebook'
  const isTabletTelcelMx = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx' && ctx.tradein.sbu === 'Tablet'
  const isSmartWatchTelcelMx = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx' && ctx.tradein.sbu === 'Smartwatch'
  const isTabletTelcelCorpMx = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx' && ctx.tradein.sbu === 'Tablet'
  const isSmartWatchTelcelCorpMx = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx' && ctx.tradein.sbu === 'Smartwatch'
  const isSmartWatchHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl' && ctx.tradein.sbu === 'Smartwatch'
  const isTabletHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl' && ctx.tradein.sbu === 'Tablet'
  const isSmartWatchHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx' && ctx.tradein.sbu === 'Smartwatch'
  const isSmartWatchHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe' && ctx.tradein.sbu === 'Smartwatch'
  const isTabletHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx' && ctx.tradein.sbu === 'Tablet'
  const isTabletHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe' && ctx.tradein.sbu === 'Tablet'
  const isTabletTecnobuyChile = configSeller.config.s3.FOLDER_APP === 'ti_tecnobuy_cl' && ctx.tradein.sbu === 'Tablet'
  // Indica si el checklist aplica para este seller/dispositivo. Se usa tanto para
  // mostrar/ocultar el módulo como para decidir si se auto-abre en la página standalone.
  const canDoChecklist = isNovabench || isConsole(ctx.tradein.sbu) || isTabletSamsungRom || isTabletFalabella || isSmartWatchSamsungMx || isTabletSamsungMx || isSmartWatchFalabella || isSmartWatchHuaweiMx || isTabletHuaweiMx || isComputerRipleyChile || isTabletHuaweiPe || isSmartWatchHuaweiPe || isSmartWatchHuaweiChile || isTabletHuaweiChile || isTabletTelcelMx || isSmartWatchTelcelMx || isTabletTelcelCorpMx || isSmartWatchTelcelCorpMx ||
  isTabletHuaweiOnlineChile || isSmartWatchHuaweiOnlineChile || isTabletHuaweiOnlineMexico || isTabletHuaweiOnlinePeru || isSmartWatchHuaweiOnlineMexico || isSmartWatchHuaweiOnlinePeru || isTabletTecnobuyChile
  console.log('isComputerRipleyChile', isComputerRipleyChile)
  // console.log('🚀 ~ JSON:', { variable1: import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '', variable2: import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined, variable3: import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) })

  console.log('1', import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '')
  console.log('2', import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined)
  console.log('entre al checklist', isConsole(ctx.tradein.sbu), isNovabenchFlabella)
  console.log('entre al checklist', isNovabench, isNovabenchFlabella)
  // console.log('3', import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)))

  useEffect(() => {
    const filteredQuestions = ctx.questions.filter((e: any) => {
      const type = isNovabench
        ? 'COMPUTER-NOVABENCH-V2'
        : ctx.tradein.sbu === 'Notebook'
          ? 'COMPUTER'
          : ctx.tradein.sbu === 'Tablet'
            ? 'TABLET'
            : isConsole(ctx.tradein.sbu)
              ? ctx.tradein.brand === 'Sony'
                ? 'PS4'
                : 'NINTENDO'
              : 'SMARTWATCH'
      return e.type.toUpperCase() === type
    })
    // Si es Tablet Samsung MX, quitar la id_question 26
    if (isTabletSamsungMx) {
      const index = filteredQuestions.findIndex((q: any) => q.id_question === 26)
      if (index !== -1) {
        filteredQuestions.splice(index, 1)
      }
    }
    console.log('filteredQuestions --->', filteredQuestions)
    if (filteredQuestions.length !== questionsLength) {
      setQuestionsLength(filteredQuestions.length)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.questions, ctx.tradein.sbu, questionsLength])

  // Página standalone: abre el checklist automáticamente cuando aplica y aún no fue respondido.
  useEffect(() => {
    if (autoOpen && canDoChecklist && ctx.tradein.id !== 0 && ctx.tradein.entry_form_status === 0 && !ctx.openModal) {
      saveCtx({ ...ctx, openModal: true })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpen, canDoChecklist, ctx.tradein.id])

  const handleChange = (question: string, answerText: string, score: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedAnswer = parseInt(event.target.value)
    const idQuestion = parseInt(event.target.name.split('_')[1])

    const answerIndex = ctx.answers.findIndex(answer => answer.id_question === idQuestion)

    if (answerIndex >= 0) {
      ctx.answers[answerIndex] = { id_question: idQuestion, question, text_answer: answerText, id_answer: selectedAnswer, score }
    } else {
      ctx.answers.push({ id_question: idQuestion, question, text_answer: answerText, id_answer: selectedAnswer, score })
    }

    saveCtx({
      ...ctx,
      answers: ctx.answers
    })
  }

  const handleSave = async () => {
    setLoading(true)
    const objChecklist = {
      stage: 5,
      id_tradein: ctx.tradein.id,
      array_answers: ctx.answers,
      id_user: userState.id,
      seller: slug
    }
    await webApiService.update(objChecklist)
      .then(() => {
        saveCtx({ ...ctx, reload: true, openModal: false })
        enqueueSnackbar('Checklist ingresado!', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el checklist.', { variant: 'error' })
        saveCtx({ ...ctx, reload: false })
        console.log('error ==>', error)
      }).finally(() => {
        setLoading(false)
      })
  }

  const getSelectedAnswer = (idQuestion: number) => {
    const answer = ctx.answers.find(answer => answer.id_question === idQuestion)
    return answer && answer.id_answer !== undefined ? answer.id_answer.toString() : ''
  }

  console.log('(isNovabench && ctx.statusHistory.includes(2))', ctx)

  /* la tarjeta entera se oculta con hidden={!canDoChecklist}; además, aunque canDoChecklist sea true,
     el botón solo aparece cuando no está cargando y la condición de serie/estado permite hacer el
     checklist — si no, en su lugar se muestra solo una alerta (sin botón), así que se replica esa
     condición para no mostrar la acción en el footer cuando la tarjeta tampoco la mostraba. */
  const canShowChecklistAction = canDoChecklist && !loading &&
    ((ctx.tradein.serie !== null && !isNovabench) ||
      (isNovabench && ![1, 6].includes(ctx.tradein.id_status)) ||
      (ctx.tradein.serie === null && (isSmartWatchHuaweiOnlineMexico || isTabletHuaweiOnlineMexico || isSmartWatchHuaweiOnlineChile || isTabletHuaweiOnlineChile)))

  const inlineAction = useStepFooterAction(
    canShowChecklistAction
      ? (
        <Button onClick={() => saveCtx({ ...ctx, openModal: true })}>
          {ctx.tradein.entry_form_status === 0 ? 'Realizar Checklist' : 'Respuestas aquí'}
        </Button>
        )
      : null,
    [canShowChecklistAction, ctx.tradein.entry_form_status]
  )

  /*  console.log('ctx.tradein.entry_form_status++++++++++++++++++++++++++', ctx.questions.length > 0 && ctx.questions
      .filter((e: any) => {
        const type = isNovabench
          ? 'COMPUTER-NOVABENCH'
          : ctx.tradein.sbu === 'Notebook'
            ? 'COMPUTER'
            : ctx.tradein.sbu === 'Tablet'
              ? 'TABLET'
              : ctx.tradein.sbu === 'Consolas'
                ? ctx.tradein.brand === 'Sony'
                  ? 'PS4'
                  : 'NINTENDO'
                : 'SMARTWATCH'
        return e.type.toUpperCase() === type
      })) */
  return (
    <StepCard icon={<MdChecklist />} title='Checklist' subtitle='Validación técnica del equipo' hidden={!canDoChecklist}>
      {/* <div>
        {
            isFalabellaChile && ctx.tradein.id_status === 1 && ctx.tradein.sbu === 'Notebook' &&
              <p className='text-sm p-4 bg-yellow-100 border border-yellow-300 rounded-md text-black mb-4 flex items-center'>
                Dispositivo debe ser aprobado por Novabench
              </p>
        }
      </div> */}
      {loading
        ? <Spinner />
        : (
          <div
            className='mt-2'
            hidden={!canDoChecklist}
          >
            {/* Sólo Huawei Online (MX y CL) puede hacer el checklist sin serie: la ingresa recién en bodega (estado 11). */}
            {(ctx.tradein.serie !== null && !isNovabench) || (isNovabench && ![1, 6].includes(ctx.tradein.id_status)) || (ctx.tradein.serie === null && (isSmartWatchHuaweiOnlineMexico || isSmartWatchHuaweiOnlinePeru || isTabletHuaweiOnlineMexico || isTabletHuaweiOnlinePeru || isSmartWatchHuaweiOnlineChile || isTabletHuaweiOnlineChile))
              ? ctx.tradein.entry_form_status === 0
                ? (
                  <div>
                    <p className='mb-2'>El formulario permite validar el estado funcional del equipo a nivel de sistema y hardware.</p>
                    <p className='text-sm p-4 bg-blue-100 border border-blue-300 rounded-md text-black mb-4 flex items-center'>
                      <MdInfo className='me-2 text-blue-500 text-xl' />
                      Debe realizar el checklist para generar el contrato
                    </p>
                  </div>
                  )
                : (
                  <div>
                    <p className='text-sm p-4 bg-green-100 border border-green-300 rounded-md text-black mb-4 flex items-center'>
                      Checklist ingresado con éxito.
                    </p>
                  </div>)
              : (
                <p className='text-sm p-4 bg-yellow-100 border border-yellow-300 rounded-md text-black mb-4 flex items-center'>
                  {isNovabench ? 'Dispositivo debe ser aprobado por Novabench' : 'Debe ingresar el numero de serie para realizar el Checklist'}
                </p>
                )}
          </div>
          )}

      <Modal isOpen={ctx.openModal} onClose={() => saveCtx({ ...ctx, openModal: false })} size='5xl' scrollBehavior='inside'>
        <ModalContent>
          <ModalHeader className='flex flex-col gap-1'>{ctx.tradein.entry_form_status === 0 ? 'Checklist' : 'Respuestas Checklist'}</ModalHeader>
          <ModalBody>
            {
                ctx.tradein.entry_form_status === 0
                  ? (
                    <div className='flex flex-col gap-2'>
                      {ctx.questions.length > 0 && ctx.questions
                        .filter((e: any) => {
                          const type = isNovabench
                            ? 'COMPUTER-NOVABENCH-V2'
                            : ctx.tradein.sbu === 'Notebook'
                              ? 'COMPUTER'
                              : ctx.tradein.sbu === 'Tablet'
                                ? 'TABLET'
                                : isConsole(ctx.tradein.sbu)
                                  ? ctx.tradein.brand === 'Sony'
                                    ? 'PS4'
                                    : 'NINTENDO'
                                  : 'SMARTWATCH'
                                  // Excluir id_question 26 solo para isTabletSamsungMx
                          if (isTabletSamsungMx && e.id_question === 26) return false
                          return e.type.toUpperCase() === type
                        })
                        .map((row: any, index: number) => (
                          <div key={index} className='rounded-lg bg-slate-100 text-start p-3'>
                            <RadioGroup
                              label={row.question}
                              name={'question_' + String(row.id_question)}
                              value={getSelectedAnswer(row.id_question)}
                              onChange={(e) => {
                                const selectedAnswer = e.target.value
                                const selectedAnswerText = JSON.parse(row.answers_json).find((answer: any) => answer.id_answer.toString() === selectedAnswer)?.answer || ''
                                const selectedScore = JSON.parse(row.answers_json).find((answer: any) => answer.id_answer.toString() === selectedAnswer)?.score || ''
                                handleChange(row.question, selectedAnswerText, Number(selectedScore), e as React.ChangeEvent<HTMLInputElement>)
                              }}
                            >
                              {/* {row.answers_json} */}
                              {JSON.parse(row.answers_json).map((e: any) => (
                                <Radio key={e.id_answer} value={e.id_answer.toString()}>{e.answer}</Radio>
                              ))}
                            </RadioGroup>
                          </div>
                        ))}
                    </div>
                    )
                  : (
                    <div className='grid grid-cols-2 gap-4'>
                      {
                        ctx.entrys.map((entry: any, index: number) => (
                          entry.entrys.map((row: any, rowIndex: number) => {
                            return (
                              <div key={`${index}-${rowIndex}`} className='col-span-2 md:col-span-1'>
                                <div className='rounded-lg bg-slate-100 text-start p-3'>
                                  <p className='mb-2 text-gray-500'>{row.question}</p>
                                  <p className='font-bold'>{row.text_answer}</p>
                                </div>
                              </div>
                            )
                          })
                        ))
                      }
                    </div>
                    )
              }
          </ModalBody>
          <ModalFooter>
            <Button
              size='sm'
              variant='destructive'
              onClick={() => saveCtx({ ...ctx, openModal: false })}
            >
              Cerrar
            </Button>
            <Button size='sm' type='submit' disabled={loading || ctx.answers.length !== questionsLength} onClick={handleSave} style={{ display: ctx.tradein.entry_form_status === 0 ? 'block' : 'none' }}>
              {loading ? 'Enviando...' : 'Enviar'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* Sin footer compartido (página de detalle clásica) el botón del paso se dibuja acá. */}
      {inlineAction && <div className='flex justify-end pt-4'>{inlineAction}</div>}
    </StepCard>
  )
}

export default Checklist
